import { States } from '../../../../../../constants';

export const anyApply = [
  {
    id: 'neighborhoodBased',
    name: 'neighborhoodBased',
    label: 'Neighborhood Based',
  },
  {
    id: 'chdoDesignation',
    name: 'chdoDesignation',
    label: 'CHDO Designation',
  },
  {
    id: 'faithBased',
    name: 'faithBased',
    label: 'Faith Based',
  },
  {
    id: 'minorityOwnedCertified',
    name: 'minorityOwnedCertified',
    label: 'Certified as a Minority Owned',
  },
  {
    id: 'veteranOwned',
    name: 'veteranOwned',
    label: 'Veteran Owned',
  },
  {
    id: 'veteranOwnedCertified',
    name: 'veteranOwnedCertified',
    label: 'Certified as Veterans Owned Based',
  },
  {
    id: 'bipocOwned',
    name: 'bipocOwned',
    label: 'BIPOC Owned',
  },
  {
    id: 'bipocLed',
    name: 'bipocLed',
    label: 'BIPOC Led',
  },
  {
    id: 'nonProfit',
    name: 'nonProfit',
    label: 'Non-Profit',
  },
];

const validStateOptions: string[] = [];
States.forEach((state) => {
  validStateOptions.push(state.name);
});
